import { Component } from 'react';
/* eslint-disable react/prefer-stateless-function */
export default class Column extends Component {
}
